// NOTE1: this is the source of truth of payment types for market sites, but there is a separate PaymentTypeEnum still around for LTO.

// NOTE2: The codes for the payments should match one-to-one with the CREW database (see comment block below).
// The one exception to this rule is the WIRE type payments, which have a different database structure.

// TODO: consolidate enum files. There's another PaymentType under ns-util.
const PaymentType = {
  VISA: 0,
  MC: 1, // MASTERCARD
  DISC: 2, // DISCOVER
  AMEX: 3, // AMERICAN_EXPRESS
  AEON: 4, // SWITCH ?
  MPOS: 5, // mPos (Thailand)
  PPAL: 119, // PAYPAL
  PROV: 7, // Provincial Payment - Used in Venezuela (mispagosprovincial.com)
  WIRE: 8,
  DINC: 9, // DINERS
  COD: 10,
  PROPAY: 14,
  ISRA: 15,
  ARGE: 16, // Argencard
  LCAB: 17, // Cabal
  ITAL: 18, // ItalCred
  TARJ: 19, // Tarjeta Naranja
  TARS: 20, // Tarjeta Shopping
  JCB: 21,
  CUP: 22, // China Union Pay
  ALIP: 23, // ALIPAY
  IDEA: 24, // IDEAL
  // WIRES :: The wires are the only exception to the rule that the codes should match one-to-one with the Crew database (see below)
  VIB_WIRE: 25,
  ACB_WIRE: 26,
  VCB_WIRE: 27,
  AGRIBANK_WIRE: 28,
  // END WIRES
  CR: 29, // NUSKIN_CREDIT
  MAS: 30, // Tarjeta Mas
  SDD: 54, // SEPA
  CEDN: 98, // CEDYNA
  PWEB: 102, // PWEB
  DBS: 103, // DBS (Asia Pay (DBS bank) for SG Installment)
  UOB: 104, // UOB (Asia Pay (UOB bank) for SG Installment)
  MBB: 105, // MBB (Asia Pay (MBB bank) for MY Installment)
  PBB: 106, // PBB (Asia Pay (PBB bank) for MY Installment)
  KBANK: 107, // KBANK (Asia Pay (KBANK bank) for TH Installment)
  BCA: 108, // BCA (SPEED (BCA bank) for ID Installment)
  BDO: 109, // BDO (Asia Pay (BDO bank) for PH Installment)
  DINE: 110, // Payment type for Italy Diner club card
  APVN: 113, // APVN (Asia Pay for VN Installment)
  KLIK: 114, // BCA KLIK Pay
  CIMB: 115,
  PERMATA: 116, // Permata payment type
  VISD: 117, // Visa debit card for Mexico
  MCD: 118, // Master debit card for Mexico
  UOB_2C2P: 120, // UOB-2C2P (Asia Pay (UOB-2C2P) for SG)
  CITI: 121, // CITI (Asia Pay (CITI bank) for MY Installment)
  HSBC: 122, // HSBC (Asia Pay (HSBC bank) for MY Installment)
  BCAI: 123, // BCA installments
  CENC: 125,
  AMIN: 129,
};

PaymentType.credit = [
  PaymentType.VISA,
  PaymentType.MC,
  PaymentType.DISC,
  PaymentType.AMEX,
  PaymentType.JCB,
  PaymentType.ISRA,
  PaymentType.DINC,
  PaymentType.LCAB,
  PaymentType.MAS,
  PaymentType.TARJ,
  PaymentType.TARS,
  PaymentType.ARGE,
  PaymentType.CENC,
  PaymentType.ITAL,
  PaymentType.DINE,
  PaymentType.VISD,
  PaymentType.MCD,
];

PaymentType.zooz = {
  0: 'VISA',
  1: 'MASTERCARD',
  3: 'AMEX',
  9: 'DINERS',
  16: 'ARGENCARD',
  17: 'CABAL',
  19: 'NARANJA',
  20: 'SHOPPING',
  125: 'CENCOSUD',
  /*,
    :"RAPIPAGO",
    "PAGOFACIL",
    "BAPRO",
    :"COBRO_EXPRESS",
    :"RIPSA" */
};

export default PaymentType;
